"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var useMNetScript = function useMNetScript(url) {
  var componentIsMounted = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (componentIsMounted.current) {
      var sct;
      window._mNHandle = window._mNHandle || {};
      window._mNHandle.queue = window._mNHandle.queue || [];

      (function () {
        sct = document.createElement('script');
        var sctHl = document.getElementsByTagName('script')[0];
        sct.type = 'text/javascript';
        sct.src = url;
        sct.async = 'async';
        sct.async = true;
        sctHl.parentNode.insertBefore(sct, sctHl);
      })();
    }

    return function () {
      componentIsMounted.current = false;
    }; // eslint-disable-next-line
  }, [url]);
};

var _default = useMNetScript;
exports.default = _default;

//# sourceMappingURL=useMNetScript.js.map